//
//
//
//
//
//
//
//
//
//
//
//


export default {
    name: "SortIconsComponent",
    props: {
        title: { type: String, default: "" },
        value: { type: String, default: "" },
        interface: { type: String, default: "" },
        positionCenter: { type: Boolean, default: false },
        currentSortValue: { type: String, default: "" },
        currentSortingPreferences: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            pageName: "sort-icons-component",
            sortType: ""

        };
    },
    watch: {
        currentSortValue: {
            handler(newValue) {
                if (newValue !== this.value) {
                    this.sortType = "";
                }
            },
            immediate: true
        },
        currentSortingPreferences: {
            handler(newValue) {
                if (newValue.sortType && newValue.sortBy === this.value) {
                    this.sortType = newValue.sortType;
                } else {
                    this.sortType = "";
                }
            },
            immediate: true,
            deep: true
        }
    },

    methods: {
        sortBy() {
            if (this.sortType === "ASC") {
                this.sortType = "";
                this.value = "";
            } else if (this.sortType === "DESC") {
                this.sortType = "ASC";
            } else {
                this.sortType = "DESC";
            }
            const payload = {
                sortType: this.sortType,
                sortBy: this.value
            };
            this.$emit("sort", payload);
        }
    }

};
